// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconArrowRight = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.522 19.515a.75.75 0 01.03-1.06l6.563-6.205H4a.75.75 0 010-1.5h15.115L12.55 4.545a.75.75 0 111.03-1.09l7.934 7.5a.75.75 0 010 1.09l-7.933 7.5a.75.75 0 01-1.06-.03z"
      fill="currentColor"
    />
  );
export default SvgIconArrowRight;
